(function ($) {
    function getInt($element, attribute, fallback) {
        var value = parseInt($element.attr(attribute), 10);

        return Number.isNaN(value) ? fallback : value;
    }

    function getBool($element, attribute) {
        return $element.attr(attribute) === '1';
    }

    function getSlideBy($element) {
        return $element.attr('data-slide-by') === 'page' ? 'page' : 1;
    }

    function getNavText() {
        return [
            "<span class='sr-only'>Previous slide</span><i class='icon-angle-left' aria-hidden='true'></i>",
            "<span class='sr-only'>Next slide</span><i class='icon-angle-right' aria-hidden='true'></i>",
        ];
    }

    function cleanDuplicateControls($carousel) {
        $carousel.children('.owl-nav').not(':first').remove();
        $carousel.children('.owl-dots').not(':first').remove();
    }

    function syncCarouselWidth($carousel) {
        var $parent = $carousel.parent();
        var parentWidth = Math.floor($parent.innerWidth());

        if (parentWidth > 0) {
            $carousel.css('width', parentWidth + 'px');
        }
    }

    function refreshCarousel($carousel) {
        syncCarouselWidth($carousel);
        $carousel.trigger('refresh.owl.carousel');
        cleanDuplicateControls($carousel);
    }

    function initCarousel(selector, defaults) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var desktopItems = getInt($carousel, 'data-items-desktop', defaults.desktopItems);
            var tabletItems = getInt($carousel, 'data-items-tablet', defaults.tabletItems);
            var mobileItems = getInt($carousel, 'data-items-mobile', defaults.mobileItems);
            var itemCount = getInt($carousel, defaults.countAttribute, 0);
            var hasMultiplePages = itemCount > desktopItems;
            var gap = getInt($carousel, 'data-gap', defaults.gap);
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop');
            var autoplay = getBool($carousel, 'data-autoplay');
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            function responsiveOptions(items) {
                return {
                    items: items,
                    loop: loop && itemCount > items,
                    autoplay: autoplay && itemCount > items,
                };
            }

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                margin: gap,
                items: desktopItems,
                slideBy: getSlideBy($carousel),
                loop: loop && hasMultiplePages,
                autoplay: autoplay && hasMultiplePages,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                // Owl disables controls when all items fit at the active
                // breakpoint; desktop capacity must not disable mobile controls.
                nav: arrows,
                dots: dots,
                navText: getNavText(),
                responsive: {
                    0: responsiveOptions(mobileItems),
                    768: responsiveOptions(tabletItems),
                    1200: responsiveOptions(desktopItems),
                },
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initSingleSlideCarousel(selector) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var slideCount = getInt($carousel, 'data-slide-count', 0);
            var hasMultipleSlides = slideCount > 1;
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultipleSlides;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultipleSlides;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 1,
                margin: 0,
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultipleSlides,
                dots: dots && hasMultipleSlides,
                navText: getNavText(),
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function refreshCarousels() {
        $('.gallery-slider.owl-carousel, .block-cpt-slider.owl-carousel, .taxonomy-posts-slider.owl-carousel, .logos-slider.owl-carousel, .grid-card-slider.owl-carousel, .text-image-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                refreshCarousel($carousel);
            }
        });
    }

    function debounce(callback, delay) {
        var timer = null;

        return function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, delay);
        };
    }

    function initLightboxes() {
        if (!$.fn.lightGallery) {
            return;
        }

        $('.gallery-lightbox').each(function () {
            var $gallery = $(this);

            if ($gallery.data('ddLightGallery')) {
                return;
            }

            $gallery.lightGallery({
                selector: '.gallery-lightbox-item',
                share: true,
                download: true,
                rotate: false,
                showThumbByDefault: true,
                loop: false,
                thumbnail: true,
                allowMediaOverlap: true,
                toggleThumb: true,
            });

            // Owl rebuilds clones without the original LightGallery handlers.
            // Open the matching original so clones do not duplicate gallery items.
            $gallery.on('click.ddLightGallery', '.owl-item.cloned .gallery-lightbox-item', function (event) {
                event.preventDefault();
                var index = $(this).attr('data-gallery-index');
                $gallery.find('.owl-item:not(.cloned) .gallery-lightbox-item').filter(function () {
                    return $(this).attr('data-gallery-index') === index;
                }).first().trigger('click');
            });

            $gallery.data('ddLightGallery', true);
        });
    }

    function initProjectCards() {
        $('[data-project-comparison]').each(function () {
            var comparison = this;
            var $comparison = $(comparison);
            var $range = $comparison.find('.project-comparison-range');
            var pointerStartX = null;
            var rangeDragged = false;

            if ($comparison.data('ddProjectComparison')) {
                return;
            }

            $range.on('input.ddProjectComparison change.ddProjectComparison', function () {
                comparison.style.setProperty('--comparison-position', this.value + '%');
            });

            $range.on('pointerdown.ddProjectComparison', function (event) {
                pointerStartX = event.originalEvent.clientX;
                rangeDragged = false;
            });

            $range.on('pointermove.ddProjectComparison', function (event) {
                if (pointerStartX === null) {
                    return;
                }

                if (Math.abs(event.originalEvent.clientX - pointerStartX) > 5) {
                    rangeDragged = true;
                }
            });

            $range.on('pointerup.ddProjectComparison pointercancel.ddProjectComparison', function () {
                pointerStartX = null;
            });

            $range.on('click.ddProjectComparison', function (event) {
                event.stopPropagation();

                if (!rangeDragged) {
                    $comparison.trigger('click');
                }

                rangeDragged = false;
            });

            $comparison.data('ddProjectComparison', true);
        });

        $('[data-project-card]').each(function () {
            var $card = $(this);
            var $gallery = $card.find('.project-card-gallery');
            var openGallery = function () {
                $gallery.find('.gallery-lightbox-item').first().trigger('click');
            };

            if ($card.data('ddProjectCard') || !$gallery.length) {
                return;
            }

            $card.on('click.ddProjectCard', '[data-project-gallery-open]', function (event) {
                if ($(event.target).closest('.project-comparison-range').length) {
                    return;
                }

                event.preventDefault();
                openGallery();
            });

            $card.on('keydown.ddProjectCard', '[data-project-gallery-open]', function (event) {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                event.preventDefault();
                openGallery();
            });

            $card.data('ddProjectCard', true);
        });
    }

    $(function () {
        initLightboxes();
        initProjectCards();

        initCarousel('.gallery-slider.owl-carousel', {
            countAttribute: 'data-image-count',
            desktopItems: 1,
            tabletItems: 1,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.block-cpt-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.taxonomy-posts-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.logos-slider.owl-carousel', {
            countAttribute: 'data-logo-count',
            desktopItems: 4,
            tabletItems: 3,
            mobileItems: 2,
            gap: 24,
        });

        initCarousel('.grid-card-slider.owl-carousel', {
            countAttribute: 'data-card-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initSingleSlideCarousel('.text-image-slider.owl-carousel');

        $(window).on('load', refreshCarousels);
        $(window).on('resize orientationchange', debounce(refreshCarousels, 150));
    });
})(jQuery);
